const getPresencesResponse = (response) => {
  const presenceData = response?.data;

  const clockInTime = presenceData?.hostPresence?.clockIn?.time;
  const clockOutTime = presenceData?.hostPresence?.clockOut?.time;
  const workDate = presenceData?.hostPresence?.workDate;

  const clockInViolations = presenceData?.hostPresence?.clockIn?.violations;
  const clockInNote = presenceData?.hostPresence?.clockIn?.note;
  const clockOutViolations = presenceData?.hostPresence?.clockOut?.violations;
  const clockOutNote = presenceData?.hostPresence?.clockOut?.note;

  const isClockedIn = !!clockInTime && !clockOutTime;

  const isTaskSubmitted = !!presenceData?.isSubmitTask;
  const isClockInToday = presenceData?.isClockInToday;
  const isClockInTomorrow = presenceData?.isClockInTomorrow;

  const streamingSessions = [...(presenceData?.streamingSessions ?? [])].sort((a, b) => a.sessionId - b.sessionId);
  const lastSession = streamingSessions[streamingSessions.length - 1];
  const isLivestreaming = !!lastSession?.clockIn?.time && !lastSession?.clockOut?.time;

  return {
    clockInTime,
    clockOutTime,
    workDate,
    clockInViolations,
    clockInNote,
    clockOutViolations,
    clockOutNote,
    isClockedIn,
    isTaskSubmitted,
    isClockInToday,
    isClockInTomorrow,
    streamingSessions,
    lastSession,
    isLivestreaming,
  };
};

export default getPresencesResponse;
